
import {
  Switch,
  Button,
  Icon,
  Checkbox,
  Chip,
  FormControlLabel,
  Link,
  Tooltip,
  Typography,
  PropTypes,
  IconButton,
  ListItemIcon,
  TextField,
  MenuItem,
  Grid,
  Popover,
  List,
  ListItem,
  ListItemText,
  Divider,
  Card,
  CardContent,
  InputLabel,
  Select,
  Modal,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  DialogContentText,
  Backdrop,
  CircularProgress,
  Alert,
  AlertTitle,
  Theme,
  TextareaAutosize,
} from "@mui/material";
import React, { useState, useEffect, useContext } from "react";
import { useLocalStorage } from "src/utils/LocalStorageHook";
import { createStyles, makeStyles } from '@mui/styles';
import { DEX_Requeue } from "src/utils/PostAdmin";
import { downloadCustomersExcel, getDEXReport } from "src/utils/GetAdmin";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    centerDiv: {
      textAlign: "center"
    },
    root: {},
    card: {},
    accordion: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(1),
    },
    primary: {
      marginTop: theme.spacing(2),
    },
    checkbox: {
      padding: 0,
    },
    divWidth: {
      width: "100%",
    },
    gridSpaceable: {
      padding: theme.spacing(2),
    },
    gridMarginTop: {
      marginTop: theme.spacing(2),
    },
    paragraph: {
      padding: theme.spacing(1),
    },
    paragraphAct: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
    paper: {
      position: 'absolute',
      backgroundColor: theme.palette.background.paper,
      border: '1px solid #000',
      boxShadow: theme.shadows[4],
      padding: theme.spacing(2, 2, 2),
    },
    modalInput: {
      width: "350px",
    },
    searchField: {
      width: "35%",
    },
    searchCard: {
      display: "flex",
    },
    textArea: {
      width: ' 100%',
      height: '200px !important',
      display: 'block',
      background: 'transparent',
      color: theme.palette.mode == 'dark' ? '#fff' : '#000'
    },

    logcard: {
      display: "flex",
      flexWrap: "wrap"
    }

  })
);

const GenerateCustomerExcel = async (customersData: any) => {
  const workbook = new ExcelJS.Workbook();
  // creating worksheet for overview.
  const predefinedOrgs = [
    "4100",
    "4200",
    "4400",
    "4500",
    "4600",
    "4700",
    "4800",
    "4900",
    "5000",
    "5200",
    "5300",
  ];
  const predefinedCustomers = ["MEI", "CASTLE", "COINCO", "OTHERS"];
  const customersOverviewData: any =
    customersData[0]?.org_ovrvw_by_vndrgrp || [];
  const workSheetOverView = workbook.addWorksheet("OVERVIEW");
  workSheetOverView.mergeCells("A1:I1");
  workSheetOverView.getCell(
    "A1"
  ).value = `Active Customers with Active SubEquipments who received Last DEX on or before ${customersData[0]?.on_or_before}`;
  workSheetOverView.getCell("A3").value = "Sales Org";
  workSheetOverView.getCell("B3").value = "Count";
  workSheetOverView.getCell("D3").value = "Sales Org";
  workSheetOverView.getCell("E3").value = "Vendor Group";
  workSheetOverView.getCell("F3").value = "Count";
  workSheetOverView.getCell("H3").value = "Vendor Group";
  workSheetOverView.getCell("I3").value = "Count";

  let serialIndex = 0;
  predefinedOrgs.forEach((ele: any, index: number) => {
    const filteredOrg = customersOverviewData.filter(
      (item: any) => item.sales_org === ele
    );
    const reducedCount = filteredOrg.reduce((acc: any, next: any) => {
      return acc + next.cnt;
    }, 0);

    workSheetOverView.getCell(`A${index + 4}`).value = ele;
    workSheetOverView.getCell(`B${index + 4}`).value = reducedCount;
    //
    filteredOrg.forEach((item: any) => {
      workSheetOverView.getCell(`D${serialIndex + 4}`).value = ele;
      workSheetOverView.getCell(`E${serialIndex + 4}`).value =
        item.vendor_group;
      workSheetOverView.getCell(`F${serialIndex + 4}`).value = item.cnt;
      serialIndex = serialIndex + 1;
    });
  });

  predefinedCustomers.forEach((ele: any, index: number) => {
    //
    const filteredCustomer = customersOverviewData.filter(
      (item: any) => item?.vendor_group.toLowerCase() === ele.toLowerCase()
    );
    const reducedCount = filteredCustomer.reduce((acc: any, next: any) => {
      return acc + next.cnt;
    }, 0);

    workSheetOverView.getCell(`H${index + 4}`).value = ele;
    workSheetOverView.getCell(`I${index + 4}`).value = reducedCount;
  });

  // Creating worksheet for differnt Orgs
  const filterArray = ["mei", "castle", "coinco"];
  const CommomColumns = [
    { header: "Sales Org", key: "sales_org", width: 10 },
    { header: "Delivering Plant", key: "delivering_plant", width: 10 },
    { header: "Master Route", key: "master_route", width: 10 },
    { header: "Customer Number", key: "customer_num", width: 10 },
    { header: "Equipment Number", key: "equipment_num" },
    { header: "Sub Serial Number", key: "sub_serial_num", width: 10 },
    { header: "Device ID Key", key: "device_id_key", width: 10 },
    { header: "Last Processed Dex", key: "last_processed_dex", width: 10 },
    { header: "Customer ID", key: "customerid", width: 10 },
    { header: "Provider ID", key: "providerid", width: 10 },
    { header: "Application ID", key: "applicationid", width: 10 },
    { header: "Device ID", key: "deviceid", width: 10 },
    { header: "Received Date Time", key: "receiveddatetime", width: 10 },
    { header: "Days Since Last Processed DEX", key: "day_snc_lst_procsd", width: 10 },
  ];

  const customersFullData: any = customersData[0]?.full_detail || [];

  filterArray.forEach((item: string) => {
    const workSheet = workbook.addWorksheet(item.toUpperCase());
    workSheet.columns = CommomColumns;
    const filteredData = customersFullData.filter(
      (ele: any) => ele?.vendor_group.toLowerCase() === item
    );
    const excelWorkSheetData: any = [];
    filteredData.forEach((ele: any) => {
      let dataObject: any = {
        sales_org: ele.sales_org,
        delivering_plant: ele.delivering_plant,
        master_route: ele.master_route,
        customer_num: ele.customer_num,
        equipment_num: ele.equipment_num,
        sub_serial_num: ele.sub_serial_num,
        device_id_key: ele.device_id_key,
        last_processed_dex: ele.last_processed_dex
          ? ele.last_processed_dex
          : "",
        customerid: ele?.customerid || "",
        providerid: ele?.providerid || "",
        applicationid: ele?.applicationid || "",
        deviceid: ele?.deviceid || "",
        receiveddatetime: ele.receiveddatetime
          ? ele.receiveddatetime
          : "",
        day_snc_lst_procsd: ele.day_snc_lst_procsd
          ? ele.day_snc_lst_procsd
          : 0,
      };
      excelWorkSheetData.push(dataObject);
    });

    //inserting the rows starting from porition 2 so that headers would not be override.
    workSheet.insertRows(2, excelWorkSheetData);
  });
  const buffer = await workbook.xlsx.writeBuffer();
  const fileName: string = customersData[0]?.on_or_before || "";
  saveAs(
    new Blob([buffer]),
    `DEXMISSING-ALL CUSTOMERS STOPPED ON OR AFTER ${fileName}.xlsx`
  );
};


export default function DEXRequeue() {
  const classes = useStyles();
  const [searchText, setSearchText] = useState("");
  const [searchTextQueuename, setSearchTextQueuename] = useState("");
  const [salesOrg] = useLocalStorage("SETTINGS.salesOrg", "");
  const [clientId] = useLocalStorage("SETTINGS.clientId", "100");
  const [showLoader, setShowLoader] = useState(false);


  function handleSearch(type: any) {
    let param = searchText
    if (type == 'queue_name') {
      param = searchTextQueuename;
    }

    if (param) {
      setShowLoader(true);
      DEX_Requeue(param, salesOrg, type).then(res => {
        setShowLoader(false)
        setSearchText('');
        setSearchTextQueuename('')
      })
    } else {
      alert('input value is  null ')
    }
  }

  // function handleDownloadExcel() {
  //   setShowLoader(true);
  //   downloadCustomersExcel(clientId, salesOrg).then(response => {
  //     //write code to geneate Excel
  //     GenerateCustomerExcel(response?.data).then((result)=>{
  //       setShowLoader(false);
  //     }).catch((error: any)=>{
  //       setShowLoader(false);   
  //     });
  //     setShowLoader(false);
  //   }).catch((error: any)=>{
  //     setShowLoader(false);
  //   });
  // }

  async function handleDownloadExcel() {
    setShowLoader(true);
    await getDEXReport('CONA').then(response => {
      setShowLoader(false);
    }).catch((error: any)=>{
      setShowLoader(false);
    });
  }

  return (
    <>
      <Grid container spacing={2} className={classes.primary}>
        {/* <Grid item xs={12} xl={12}>
          <Card className={classes.card}>
            <CardContent className={classes.searchCard}>
              <TextField value={searchText} className={classes.searchField} onChange={(e) => { setSearchText(e.target.value) }} id="standard-basic" label="Org" variant="standard" placeholder="4100,4200,4300" />
              <Button variant="contained" onClick={() => handleSearch('org')}>DEX Requeue</Button>
            </CardContent>
          </Card>

        </Grid>

        <Grid item xs={12} xl={12}>
          <Card className={classes.card}>
            <CardContent className={classes.logcard}>
              <h4> QUEUE NAME</h4>
              <TextareaAutosize value={searchTextQueuename} minRows={7} className={classes.textArea} onChange={(e) => { setSearchTextQueuename(e.target.value) }} aria-label=" DEX Queue_name" placeholder="c4203e2300000092,c4203e2300000092" onResize={false} onResizeCapture={false} />

              <Button variant="contained" onClick={() => handleSearch('queue_name')}>DEX Requeue by id</Button>
            </CardContent>
          </Card>

        </Grid> */}

        <Grid item xs={12} xl={12}>
          <Card className={classes.card}>
            <CardContent className={classes.searchCard}>
              <h3>Download the customer's data who have exceed the dex threshold</h3>
              <></>
              <Button variant="contained" onClick={() => handleDownloadExcel()}>Download Customer Excel</Button>
            </CardContent>
          </Card>

        </Grid>
      </Grid>

      
      <Backdrop sx={{ color: "#fff", zIndex: (theme: any) => theme.zIndex.drawer + 1 }} open={showLoader}>
        <CircularProgress color="primary" />
      </Backdrop>
    </>

  )
}

